import { FileDown, FileText, Loader2 } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { downloadExport } from "../lib/api";

export function ExportButtons({ base, name }) {
  const [busy, setBusy] = useState(null);
  const dl = async (fmt) => {
    setBusy(fmt);
    try {
      await downloadExport(`${base}/export/${fmt}`, `${name}.${fmt}`);
    } catch {
      toast.error("Export failed. Please try again.");
    } finally {
      setBusy(null);
    }
  };
  return (
    <div className="flex gap-2">
      <button data-testid="export-pdf" onClick={() => dl("pdf")} disabled={busy}
        className="btn-gold rounded-full px-4 py-2 text-xs font-semibold flex items-center gap-2 disabled:opacity-50">
        {busy === "pdf" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <FileDown className="h-3.5 w-3.5" />} PDF
      </button>
      <button data-testid="export-md" onClick={() => dl("md")} disabled={busy}
        className="rounded-full border border-white/15 px-4 py-2 text-xs font-medium flex items-center gap-2 hover:bg-white/5 transition-colors disabled:opacity-50">
        {busy === "md" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <FileText className="h-3.5 w-3.5" />} Markdown
      </button>
    </div>
  );
}
